import { downloadBlob, getBlob } from "../../common/actions/net";
import { getApi, postApi } from "../../common/actions/net.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import { ContentTypes } from "../../common/net/httpClient";
import Logger from "../../common/util/Logger.js";

export const SET_HUB_PRODUCTION = "SET_HUB_PRODUCTION";
export const SET_HUB_PRODUCTS = "SET_HUB_PRODUCTS";
export const SET_HUB_PRODUCTION_NEWQTY = "SET_HUB_PRODUCTION_NEWQTY";
export const CLEAR_HUB_PRODUCTION_NEWQTY = "CLEAR_HUB_PRODUCTION_NEWQTY";
export const SET_HUB_PRODUCTION_NEW_CUSTOMER = "SET_HUB_PRODUCTION_NEW_CUSTOMER";
export const SET_HUB_PRODUCTION_NEW_PRODUCT = "SET_HUB_PRODUCTION_NEW_PRODUCT";


/**
 * Gets hub overview
 * @param {number} hubId
 * @returns {func}
 */
export function getHubProduction(hubId) {
    return async dispatch => {
        try {
            // Call webApi to get a list of invoice groups
            const { payload } = await dispatch(
                getApi("FreshFoodHub/GetHubProductionQuery",
                    {
                        hubId : hubId,
                    }));

            dispatch({
                type: SET_HUB_PRODUCTION,
                payload: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av produksjonsliste mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}


/**
 * Gets hub overview
 * @param {number} hubId
 * @returns {func}
 */
export function getHubProducts(hubId) {
    return async dispatch => {
        try {
            // Call webApi to get a list of invoice groups
            const { payload } = await dispatch(
                getApi("FreshFoodHub/GetHubProductsQuery",
                    {
                        hubId : hubId,
                    }));

            dispatch({
                type: SET_HUB_PRODUCTS,
                payload: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av varer for ub mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}


/**
 * Adds a qty to the produced qty
 * @param {string} customerId
 * @param {string} productId
 * @param {int} value
 * @returns {func}
 */
export function addProducedQty(customerId, productId, value) {
    return async (dispatch, getState) => {
        try {

            const state = getState();

            // Clear any previous edited customer, which was not submitted
            if(state.freshFoodHub.editedCustomer.customerId != customerId)
            {
                dispatch({
                    type: SET_HUB_PRODUCTION_NEW_CUSTOMER,
                    customerId: customerId,
                });
            }  

            dispatch({
                type: SET_HUB_PRODUCTION_NEWQTY,
                customerId: customerId,
                product: {                    
                    productId: productId,
                    producedQty: value
                }
                
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering av produsert antal feilet.", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Adds a new product
 * @param {string} customerId
 * @param {string} productId
 * @param {string} epdNo
 * @param {string} productName
 * @returns {func}
 * 
 */
export function addNewProductToRegister(customerId, productId, epdNo, productName) {
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_HUB_PRODUCTION_NEW_PRODUCT,
                customerId: customerId,
                product: {                    
                    productId: productId,
                    epdNo: epdNo,
                    productName: productName,
                    qtyToBeProduced: 0,
                    qtyProduced: 0,
                    registeredQty: 0,
                    producedQty: 0
                }
            });       
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering av produsert antal feilet.", messageType.error));
            Logger.error(error);
        }
    };
}


/**
 * Submits edited qty
 * @returns {func}
 */
export function submitEditedProducts() {
    return async (dispatch, getState) => {
        try {

            const state = getState();

            // Clear any previous edited customer, which was not submitted
            if(state.freshFoodHub.editedCustomer.products.length > 0)
            {
                //debugger;
                // Call webApi to updated produced qty in DB.
                const  payload  = await dispatch(
                    postApi("FreshFoodHub/ProduceProductsCommand",
                        {
                            hubId : state.authentication.hubId,
                            customerId : state.freshFoodHub.editedCustomer.customerId,
                            products: state.freshFoodHub.editedCustomer.products
                        }));
                       
                if( payload.message === "OK") {
                    dispatch({
                        type: CLEAR_HUB_PRODUCTION_NEWQTY,
                    });

                    dispatch(pushSystemMessage("Varer ble oppdatert!", messageType.message));
                    // refresh display
                    await dispatch(getHubProduction(state.authentication.hubId));
                }
            }  

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering av produsert antal feilet.", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Downloads a pdf
 * @param {object} productionData
 * @param {string} token
 * @returns {func}
 */
export function showProductionListPdf(productionData, token){
    return async (dispatch, getState) => {
        try {
            const state = getState();

            const blob = await getBlob("FreshFoodHub/GenerateProductionListPdf", 
                {
                    hubId : state.authentication.hubId,
                    customerId: productionData.customerId,
                    productionDate : productionData.productionDate,                   
                }
                , token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `${productionData.productionDate}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        }
    };
}

